import React, { useContext, useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import Fade from 'react-reveal/Fade';
import { Link } from 'react-scroll';
import Typewriter from 'typewriter-effect';

import PortfolioContext from '../../context/context';

const Header = () => {
  const { hero } = useContext(PortfolioContext);
  const { title, name, subtitle, cta } = hero;

  const [isDesktop, setIsDesktop] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (window.innerWidth > 769) {
      setIsDesktop(true);
      setIsMobile(false);
    } else {
      setIsMobile(true);
      setIsDesktop(false);
    }
  }, []);

  return (
    <section id="hero" className="jumbotron">
      {' '}
      <Container>
        <Fade left={isDesktop} bottom={isMobile} duration={1000} delay={500} distance="30px">
          <h1 className="hero-title">
            {' '}
            <Typewriter
              onInit={(typewriter) => {
                typewriter
                  .pauseFor(200)
                  .typeString(title || 'Hi, my name is')
                  .start()
                  .pauseFor(1000)
              }}
              options={{
                cursor: "",
                delay: 50
              }}
            />
            <span className="hero-name">
              <Typewriter
                onInit={(typewriter) => {
                  typewriter
                    .pauseFor(1300)
                    .typeString(name || 'Kichul Kang.')
                    .start()
                    .pauseFor(1000)
                }}
                options={{
                  cursor: "",
                  delay: 50
                }}
              />
            </span>
            <br />
          </h1>
          <h1 className="hero-subtitle">
            {' '}
            <Typewriter
              onInit={(typewriter) => {
                typewriter
                  .pauseFor(2400)
                  .typeString(subtitle || 'I am a Computer Science student at Purdue University.')
                  .pauseFor(1000)
                  .start();
              }}
              options={{
                cursor: "",
                delay: 40
              }}
            />
          </h1>
        </Fade>
        <Fade left={isDesktop} bottom={isMobile} duration={1000} delay={1000} distance="30px">
          <p className="hero-cta">
            <span className="cta-btn cta-btn--hero">
              <Link to="about" smooth duration={1000}>
                {cta || 'Know more'}
              </Link>
            </span>
          </p>
        </Fade>
      </Container>
    </section>
  );
};

export default Header;
